import React, { useState } from "react";
import gql from "graphql-tag";
import { useMutation } from "@apollo/react-hooks";
import { Button, Confirm, Icon } from "semantic-ui-react";

import { FETCH_WATCH_TEAM_QUERY } from "../util/graphql";
import { FETCH_TEAM_QUERY } from "../util/graphql";
// import MyPopup from "../util/MyPopup";

function DeleteButton({ postId, callback }) {
  const [confirmOpen, setConfirmOpen] = useState(false);

  const pathname = window.location.pathname;
  const mutation =
    pathname === "/watchlist"
      ? DELETE_POST
      : pathname === "/myTeam"
      ? DELETE_TEAM_POST
      : DELETE_FARM_SYSTEM_POST;

  const [deletePost] = useMutation(mutation, {
    update(proxy) {
      setConfirmOpen(false);
      if (pathname === "/watchlist") {
        const data = proxy.readQuery({
          query: FETCH_WATCH_TEAM_QUERY,
        });
        console.log(data);
        data.getWatchlist.filter((p) => p.user !== postId);
        proxy.writeQuery({ query: FETCH_WATCH_TEAM_QUERY, data });
      } else if (pathname === "/myTeam") {
        const data = proxy.readQuery({
          query: FETCH_TEAM_QUERY,
        });
        console.log(data);
        data.getTeam.filter((p) => p.user !== postId);
        proxy.writeQuery({ query: FETCH_TEAM_QUERY, data });
      }
      if (callback) callback();
    },
    variables: {
      postId,
    },
  });
  return (
    <>
      {/* <MyPopup content={"Delete post"}> */}
      <Button
        as="div"
        color="red"
        floated="left"
        style={{ margin: 0 }}
        onClick={() => setConfirmOpen(true)}
      >
        <Icon name="trash" style={{ margin: 0 }} />
      </Button>
      {/* </MyPopup> */}
      <Confirm
        open={confirmOpen}
        content="Are You Sure You Want to Delete This Player?"
        confirmButton="Let's do it"
        onCancel={() => setConfirmOpen(false)}
        onConfirm={deletePost}
      />
    </>
  );
}

const DELETE_POST = gql`
  mutation deleteWatchPlayer($postId: String!) {
    deleteWatchPlayer(postId: $postId)
  }
`;
const DELETE_TEAM_POST = gql`
  mutation deleteTeamPlayer($postId: String!) {
    deleteTeamPlayer(postId: $postId)
  }
`;
const DELETE_FARM_SYSTEM_POST = gql`
  mutation deleteFarmSystemPlayer($postId: String!) {
    deleteFarmSystemPlayer(postId: $postId)
  }
`;

export default DeleteButton;
